// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWidgetClassRegistrationQuestionsDefinitionRequestModel from '../../model/get-widget-class-registration-questions-definition-request-model';
import GetWidgetClassRegistrationQuestionsDefinitionRequestDTO from '../dto/get-widget-class-registration-questions-definition-request-dto';
import dtoSchema from '../schemas/get-widget-class-registration-questions-definition-request-schema';

export default abstract class GetWidgetClassRegistrationQuestionsDefinitionRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWidgetClassRegistrationQuestionsDefinitionRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int32}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetWidgetClassRegistrationQuestionsDefinitionRequestDTO>): GetWidgetClassRegistrationQuestionsDefinitionRequestModel;
  static toModel(dto: DeepPartial<GetWidgetClassRegistrationQuestionsDefinitionRequestDTO> | undefined | null): GetWidgetClassRegistrationQuestionsDefinitionRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWidgetClassRegistrationQuestionsDefinitionRequestDTO> | undefined | null): GetWidgetClassRegistrationQuestionsDefinitionRequestModel | undefined {
    return dto ? new GetWidgetClassRegistrationQuestionsDefinitionRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWidgetClassRegistrationQuestionsDefinitionRequestModel> | GetWidgetClassRegistrationQuestionsDefinitionRequestModel): GetWidgetClassRegistrationQuestionsDefinitionRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetWidgetClassRegistrationQuestionsDefinitionRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWidgetClassRegistrationQuestionsDefinitionRequestModel, can not map to GetWidgetClassRegistrationQuestionsDefinitionRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
